import { SearchMode, SearchQueryStringParams } from 'components/search/utils';

export interface CityHeader {
  header: string;
  shortHeader: string;
}
export const cityHeader = (
  showSearchResults: boolean,
  stateValue: SearchMode,
  searchQuery: SearchQueryStringParams = {}
): CityHeader => {
  if (stateValue.stateType !== 'city') {
    return { header: '', shortHeader: '' };
  }
  if (showSearchResults) {
    if (stateValue.queryType.DISPLAYTERM) {
      return {
        header: `Exploring ${searchQuery.displayTerm} in ${stateValue.metroArea.name}`,
        shortHeader: `Exploring ${searchQuery.displayTerm}`,
      };
    }
    if (searchQuery.q) {
      const header = `Results for “${searchQuery.q}” in ${stateValue.metroArea.name}`;
      return {
        header,
        shortHeader: header,
      };
    }
    return {
      header: `Exploring ${stateValue.metroArea.name}`,
      shortHeader: `Exploring ${stateValue.metroArea.name}`,
    };
  }
  return {
    header: `Let's find you something delicious in ${stateValue.metroArea.name}`,
    shortHeader: `Let's find you something delicious in ${stateValue.metroArea.name}`,
  };
};
